import type { TUserType } from '@/Interfaces/Data';

export enum ENUM_LAUNCH {
  CREDITO = 'CREDITO',
  DEBITO = 'DEBITO',
}

export type Launch = ENUM_LAUNCH.CREDITO | ENUM_LAUNCH.DEBITO;

export interface LaunchBankProps {
  userType: TUserType;
}
